import React from 'react';
import { Text, TextProps } from '../../Text';
import { useCustomComponent } from '@/hooks';

export interface OfflineMessageSubtitleTextProps extends TextProps {}

const SubtitleTextComponent: React.FC<
  OfflineMessageSubtitleTextProps
> = props => {
  return <Text {...props} />;
};

export const SubtitleText: React.FC<OfflineMessageSubtitleTextProps> = (
  props: OfflineMessageSubtitleTextProps
) => {
  const Component = useCustomComponent({
    componentName: 'OfflineMessageSubtitleText',
    Component: SubtitleTextComponent,
  });

  return <Component {...props} />;
};
